module.exports = __webpack_public_path__ + "static/media/chuasoonghee.24b81183.jpg";